import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot } from '@angular/router';
import { MenuController, Platform } from '@ionic/angular';

@Injectable({
  providedIn: 'root'
})
class AuthGuardService {

  constructor(
    private menuCtrl: MenuController,
    private platform: Platform,
    private router: Router
  ) { }

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    if (this.platform.is('mobileweb') || this.platform.is('desktop')) {
      if (localStorage.user)
        return true;
      else {
        setTimeout(() => {
          this.router.navigate(['/login']);
          this.menuCtrl.enable(false);
        }, 100);
        return false;
      }
    }
    return true;
  }
}

export const AuthGuard: CanActivateFn = (next: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean => {
  return inject(AuthGuardService).canActivate(next, state);
}